import { useTranslation } from 'react-i18next';
import { GRANT_TYPES } from '@/constant/auth';
import { LoginOption } from '@/constant/sso';
import { Divider } from '@/components/core';
import { SsoSignin } from '../../pages/signin/signin-sso';
import { SigninEmail } from '../signin-email';

type SigninProps = {
  loginOption?: LoginOption;
};

export const Signin = ({ loginOption }: SigninProps) => {
  const { t } = useTranslation();

  // The password form is the default login. On the v4 API host there is no
  // "login options" endpoint that tells us whether password grant is allowed,
  // so we always render the email/password form. SSO buttons render only
  // when the parent passes an `ssoLoginOptions` prop (see signin-page.tsx,
  // which checks VITE_BLOCKS_OIDC_CLIENT_ID).
  const passwordGrantAllowed = true;
  const socialGrantAllowed = !!loginOption?.allowedGrantTypes?.includes(GRANT_TYPES.social);

  return (
    <div className="w-full">
      {passwordGrantAllowed && <SigninEmail />}
      {passwordGrantAllowed && socialGrantAllowed && (
        <div className="my-6">
          <Divider text={t('AUTH_OR')} />
        </div>
      )}
      {socialGrantAllowed && loginOption && <SsoSignin loginOption={loginOption} />}
    </div>
  );
};